const currentCultureName = "CurrentCulture";
export const CoreResource = "Core";

export function momentDateTimeFormat() {
  const currentCultureName = getCurrentCulture();
  switch (currentCultureName) {
    case "en":
      return "MM/DD/YYYY hh:mm:ss A";
    case "vi":
      return "DD/MM/YYYY hh:mm:ss A";
    default:
      return "MM/DD/YYYY hh:mm:ss A";
  }
}

export function momentDateFormat() {
  const currentCultureName = getCurrentCulture();
  switch (currentCultureName) {
    case "en":
      return "MM/DD/YYYY";
    case "vi":
      return "DD/MM/YYYY";
    default:
      return "MM/DD/YYYY";
  }
}

export function getCurrentCulture() {
  return localStorage.getItem(currentCultureName) ?? "en";
}
export function setCurrentCulture(cultureName: string) {
  localStorage.setItem(currentCultureName, cultureName);
}
